<template>
	<v-container fluid>
		<h1 class="text-center">Accés non autorisé</h1>
		<p>{{ getError }}</p>
	</v-container>
</template>
<script>
import { mapGetters } from "vuex"
export default {
	computed: {
		...mapGetters("authStore", {
			getError: "getError"
		})
	}
}
</script>
